/**
 * @license @tabler/icons-react v3.44.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

const __iconNode = [["path", { "d": "M8 13v.01", "key": "svg-0" }], ["path", { "d": "M12 17v.01", "key": "svg-1" }], ["path", { "d": "M12 12v.01", "key": "svg-2" }], ["path", { "d": "M16 14v.01", "key": "svg-3" }], ["path", { "d": "M11 8v.01", "key": "svg-4" }], ["path", { "d": "M13.148 3.476l2.667 1.104a4 4 0 0 0 4.656 6.14l.053 .132a3 3 0 0 1 0 2.296q -.745 1.18 -1.024 1.852q -.283 .684 -.66 2.216a3 3 0 0 1 -1.624 1.623q -1.572 .394 -2.216 .661q -.712 .295 -1.852 1.024a3 3 0 0 1 -2.296 0q -1.203 -.754 -1.852 -1.024q -.707 -.292 -2.216 -.66a3 3 0 0 1 -1.623 -1.624q -.397 -1.577 -.661 -2.216q -.298 -.718 -1.024 -1.852a3 3 0 0 1 0 -2.296q .719 -1.116 1.024 -1.852q .257 -.62 .66 -2.216a3 3 0 0 1 1.624 -1.623q 1.547 -.384 2.216 -.661q .687 -.285 1.852 -1.024a3 3 0 0 1 2.296 0", "key": "svg-5" }]];
const IconCookie = createReactComponent("outline", "cookie", "Cookie", __iconNode);

export { __iconNode, IconCookie as default };
//# sourceMappingURL=IconCookie.mjs.map
